<template>
    <div class="content-wrapper">
        <div class="container-lg">
            <div class="row mb-12">
                <div class="col">
                    <div class="page-title-nav row">
                        <div class="col-2 col-lg-3">
                            <router-link :to="`/member/gamelist`" class="btn btn-outline-secondary btn-custom btn-back"><i
                                    class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                                    class="d-none d-lg-block ms-2">ย้อนกลับ</span></router-link>
                        </div>
                        <div class="col-8 col-lg-6">
                            <h1 class="page-title">เล่นเกม</h1>
                        </div>
                        <div class="col-12 col-lg-3">
                            <a href="#" class="btn btn-primary btn-custom d-none"><i
                                    class="fa-icon fa-regular fa-home"></i><span>button</span></a>
                        </div>
                    </div>
                    <div class="row mb-4">
            <div class="col-6 d-grid">
                <router-link class="btn btn-label-secondary btn-custom btn-xl" :to="`/member/gamelist`">
                    <i class="fa-icon fa-regular fa-gamepad-modern"></i>เกมส์
                </router-link>

            </div>
            <div class="col-6 d-grid">
                <router-link  class="btn btn-outline-secondary btn-custom btn-xl" :to="`/member/gamehistory`">
                    <i class="fa-icon fa-regular fa-clock-rotate-left"></i>ประวัติการเล่น
                </router-link>
            </div>
        </div>
                    <div class="row">
                        <div class="col">
                            <div class="content-card mb-4">
                                <div class="content-card-title">
                                    <div class="row">
                                        <div class="col">รายการ</div>
                                    </div>

                                </div>

                                <div class="content-card-body p-0">

                                    <div class="container p-3">
                                        <div class="row height d-flex justify-content-center align-items-center">
                                            <div class="col-md-12">
                                                <div class="search">
                                                    <div class="input-group input-group-sm input-group-merge">
                                                        <span class="input-group-text"> <i
                                                                class="fa fa-search"></i></span>
                                                        <input v-model="searchgame" type="text" class="form-control"
                                                            placeholder="ค้นหาเกมส์ที่นี้" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <template v-for="(item, index) in getGames.games">
                                                <div class="col-6 col-md-4 col-lg-3 p-1" v-if="(searchgame == '') || (item.games_name.indexOf(searchgame) > 0)"
                                                    v-bind:key="index" >
                                                    <div class="row p-3">
                                                        <a href="#loginModal"
                                                                        class="-btn -btn-play js-account-approve-aware"
                                                                        @click="reqStartGame(item.id, item.games_image, item.games_provider_id)"
                                                                        v-if="isMember">
                                                                        <img :src="item.games_image"
                                                                            class=" img-fluid "
                                                                            alt="wt-pretty-gaming" width="364"
                                                                            height="231">
                                                                    </a>
                                                    </div>
                                                    <div class="row">
                                                        <div class="-title card-section text-center">{{ item.games_name }} </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <ul class="game-list">
                                                <template v-for="(item, index) in getGames.games">
                                                    <li class="nav-item -game-casino-macro-container"
                                                        v-if="(searchgame == '') || (item.games_name.indexOf(searchgame) > 0)"
                                                        v-bind:key="index">
                                                        <div class="x-game-list-item-macro js-game-list-toggle -big "
                                                            data-status="">
                                                            <div class="d-flex justify-content-center">
                                                                    <a href="#loginModal"
                                                                        class="-btn -btn-play js-account-approve-aware"
                                                                        @click="reqStartGame(item.id, item.games_image, item.games_provider_id)"
                                                                        v-if="isMember">
                                                                        <img :src="item.games_image"
                                                                            class=" img-fluid "
                                                                            alt="wt-pretty-gaming" width="364"
                                                                            height="231">
                                                                    </a>
                                                                    <a href="#loginModal"
                                                                        class="-btn -btn-play js-account-approve-aware"
                                                                        v-b-modal.modal-user-login v-else>
                                                                        <img :src="item.games_image"
                                                                            class="img-fluid"
                                                                            alt="wt-pretty-gaming" width="364"
                                                                            height="231">
                                                                    </a>
                                                            </div>
                                                            <div class="-title card-section text-center">{{ item.games_name }} </div>
                                                        </div>
                                                    </li>
                                                </template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="push">
                <div v-for="(item, id) in gamesHistoryData" :key="id">
                    <b-modal style="height: 100%;"
                        v-bind="{ id: 'gameDetailModal_' + item.agentGame, title: 'ค่ายเกม : ' + item.agentGame }"
                        scrollable hide-footer size="xl">
                        <table class="table table-sm table-hover table-bordered table-striped table-vcenter">
                            <thead class="thead-light">
                                <tr class="text-center">
                                    <th scope="col">รูป</th>
                                    <th scope="col">ชื่อเกม</th>
                                    <th scope="col">เงินเดิมพัน</th>
                                    <th scope="col">Valid Amount</th>
                                    <th scope="col">ผลชนะ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="" id="" v-for="(data, id) in item.item" :key="id">
                                    <td class="td-center">
                                        <b-img class="w-100" v-bind="{ src: data.item_image }" fluid
                                            alt="Responsive image" style="max-width: 4rem;"></b-img>
                                    </td>
                                    <td class="td-center">{{ data.item_games_name }}</td>
                                    <td class="td-center">{{ data.item_betAmount }}</td>
                                    <td class="td-center">{{ data.item_validAmount }}</td>
                                    <td v-if="data.item_winAmount > 0" class="text-green td-right">+{{
                                        numberWithCommas(data.item_winAmount) }}</td>
                                    <td v-else class="text-red td-right">{{ numberWithCommas(data.item_winAmount) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <b-button class="mt-3" variant="primary" size="sm" block
                            @click="$bvModal.hide('gameDetailModal_' + item.agentGame)">ปิด</b-button>
                    </b-modal>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import { ApiService } from '@/utils'
import { mapState, mapActions, mapGetters } from 'vuex'
const client = new ApiService({})

export default {
  async mounted () {
    if (process.env.VUE_APP_CASINO_ENABLE.toLowerCase().trim() === 'false') {
      this.$router.push('/member')
    }
    try {
      await this.getGamesList({
        type: this.$route.params.banner
      })
    } catch (error) {
    }
  },
  computed: {
    ...mapGetters([
      'getGames',
      'getGameUrl'
    ]),
    ...mapState({
      isMember: (state) => state.authModule.isMember
    })
  },
  data () {
    return {
      searchgame: ''
    }
  },
  methods: {
    ...mapActions(['getGamesList', 'getGamesUrl', 'setGameDepositCreditAll', 'setLoading']),
    async reqStartGame (gameId, game_img, game_name) {
      this.setLoading(true)
      const resp = await client.post('/game/request/start', JSON.stringify({
        id: gameId
      }))
      this.setLoading(false)
      if (resp.status_code === 'SUCCESS') {
        this.link_to_game = process.env.VUE_APP_CASINO_URL + '/' + localStorage.getItem('client_id') + '/' + resp.data._token
        this.$swal({
          text: 'คุณต้องการเข้าเล่น ' + game_name + ' ?',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ปิด',
          imageUrl: game_img,
          imageWidth: '100%'
        }).then((result) => {
          if (result.isConfirmed) {
            window.open(process.env.VUE_APP_CASINO_URL + '/' + localStorage.getItem('client_id') + '/' + resp.data._token)
          }
        })
      }
    }
  }
}
</script>

<style>
.-sub-title {
    margin-top: 1rem;
    margin-bottom: 0rem;
    padding: 0 1rem;
    font-size: 1.25rem;
    font-weight: 300;
    line-height: 1.5;
    color: #fff;
    text-align: center;
}

.div-back-title {
    background: linear-gradient(180deg, var(--color-b1-main), var(--color-b2-main));
    box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
    margin-top: 0rem;
    margin-bottom: 0rem;
    padding: 0.4rem 1rem;
    font-size: 1.25rem;
    font-weight: 300;
    line-height: 1.5;
    color: #fff;
}

.back-title {
    color: #fff;
}
</style>
